import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewCompatibilityPageNew from "../../components/CompatibilityControl/ViewCompatibilityPageNew";

const ViewCompatibilityPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb
        id="title"
        title2="Compatibility Users"
        link2="/compatibility-control"
        title="View Compatibility"
      />
      <ViewCompatibilityPageNew />
    </MasterLayout>
  );
};

export default ViewCompatibilityPage;
